document.addEventListener('DOMContentLoaded', function() {
  let autoplayInterval;
  const duration = 5000;

  const pickup_swiper = new Swiper(".pickup-swiper", {
    loop: false,
    autoplay: {
      delay: duration,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".pickup-swiper-pagination",
      type: "fraction",
      formatFractionCurrent: function (number) {
        return '0' + number;
      },
      formatFractionTotal: function (number) {
        return '0' + number;
      },
    },
    navigation: {
      nextEl: ".pickup-swiper-button-next",
      prevEl: ".pickup-swiper-button-prev",
    },
    scrollbar: {
      el: '.pickup-swiper-scrollbar',
    },
    on: {
      init: function() {
        startProgressAnimation();
      },
      slideChange: function() {
        startProgressAnimation();
      },
    },
    effect: 'fade',
fadeEffect: {
  crossFade: true
},
 speed: 1000,
  });

  function startProgressAnimation() {
    const progressRing = document.querySelector('.progress-ring__progress');
    if (!progressRing) return;
    
    const isMobile = window.innerWidth <= 768;
    const circumference = isMobile ? 106.814 : 69.115;
    
    // リセット
    progressRing.style.transition = 'none';
    progressRing.style.strokeDashoffset = circumference;
    
    // アニメーション開始
    setTimeout(() => {
      progressRing.style.transition = `stroke-dashoffset ${duration}ms linear`;
      progressRing.style.strokeDashoffset = 0;
    }, 50);
  }
});
 

$(function() {
  
  $('.footer__products__item').on('click', function() {
    // 768px以下の時だけ動作
    if (window.matchMedia('(max-width: 1000px)').matches) {
      let $currentName = $(this).find('.footer__products-name-box');
      let $currentList = $(this).find('.footer__products-detail-list');
      let $currentArrow = $(this).find('.footer__products-name-arrow');
      
      // 他のアイテムを閉じる
      $('.footer__products__item').not(this).find('.footer__products-detail-list').slideUp();
      $('.footer__products__item').not(this).find('.footer__products-name-arrow').removeClass('active');
      $('.footer__products__item').not(this).find('.footer__products-name-box').removeClass('active');
      
      
      // クリックしたアイテムを開閉
      $currentName.toggleClass('active');
      $currentArrow.toggleClass('active');
      $currentList.slideToggle();
    }
  });
});

// ヘッダーハンバーガー
document.addEventListener('DOMContentLoaded', function() {
  const menuToggleBtn = document.getElementById('menu-toggle-btn');
  const sidebarMenu = document.getElementById('sidebar-menu');
  
  if (menuToggleBtn && sidebarMenu) {
    // ドロワーが開いた時
    sidebarMenu.addEventListener('drawer:opened', function() {
      menuToggleBtn.classList.add('menu-open');
      menuToggleBtn.classList.remove('menu-close');
    });
    
    // ドロワーが閉じた時
    sidebarMenu.addEventListener('drawer:closed', function() {
      menuToggleBtn.classList.remove('menu-open');
      menuToggleBtn.classList.add('menu-close');
    });
    
    // MutationObserverでopen属性の変化を監視（フォールバック）
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (sidebarMenu.hasAttribute('open')) {
            menuToggleBtn.classList.add('menu-open');
            menuToggleBtn.classList.remove('menu-close');
          } else {
            menuToggleBtn.classList.remove('menu-open');
            menuToggleBtn.classList.add('menu-close');
          }
        }
      });
    });
    
    observer.observe(sidebarMenu, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  // 画面幅変更時にアニメーションが効いてしまうのを防止
   window.addEventListener('resize', function() {
    if (menuToggleBtn && window.innerWidth > 768) {
      menuToggleBtn.classList.remove('menu-open', 'menu-close');
    }
  });
});




//////////// 商品詳細ページ

// カラースウォッチ
$(function(){
  if (window.location.search.includes('miho_50th_anniversary_lp')) {
    return; // 美保さん特設LPページでは動作させない
  }
  $('.color-swatch__img').on('click',function(){
    var color_name = $(this).data('color');
    $('.color-swatch__name').text(color_name);

    $('.color-swatch__img-item').removeClass('active');
    $(this).parent('.color-swatch__img-item').addClass('active');
  })
});

// Youtube再生用モーダル

 $(function(){
    $('.modal-open').on('click', function(){
      var youtubeUrl = $(this).data('youtube-url');

      // 埋め込み形式のURLに変換
      var embedUrl = convertToEmbedUrl(youtubeUrl);

      $('.p-feature-contents__modal-movie-box iframe').attr('src', embedUrl);
      $('.p-feature-contents__modal').fadeIn(300).addClass('is-show');

      return false;
    });

    $('.p-feature-contents__modal-close-button').on('click', function(){
      $('.p-feature-contents__modal').fadeOut(300).removeClass('is-show');
      // 動画を停止
      $('.p-feature-contents__modal-movie-box iframe').attr('src', '');
    });
  });

  // YouTube URLを埋め込み形式に変換する関数
function convertToEmbedUrl(url) {
  if (!url) return '';

  // すでに埋め込み形式
  if (url.includes('/embed/')) {
    return url;
  }

  let videoId = '';

  // youtube.com/watch?v=VIDEO_ID
  if (url.includes('watch?v=')) {
    videoId = url.split('watch?v=')[1].split('&')[0];
  }
  // youtu.be/VIDEO_ID
  else if (url.includes('youtu.be/')) {
    videoId = url.split('youtu.be/')[1].split('?')[0];
  }
  // youtube.com/shorts/VIDEO_ID
  else if (url.includes('/shorts/')) {
    videoId = url.split('/shorts/')[1].split('?')[0];
  }

  if (!videoId) {
    console.warn('YouTube video ID could not be extracted:', url);
    return '';
  }

  return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
}
//  関連商品スワイパー（spのみ）

const related_swiper = new Swiper(".p-related-products-swiper", {
  slidesPerView:1.2,
  spaceBetween:16,
      scrollbar: {
        el: '.p-related-products__swiper-scrollbar',//.swiper-scrollbar2をスクロールバーに指定
        hide: false,// スクロールバーが常に表示される
        draggable: true, // スクロールバーをドラッグ可能にする
    },
    navigation: {
    nextEl: ".p-related-products__swiper-button-next",
    prevEl: ".p-related-products__swiper-button-prev",
  },
      breakpoints: {
        768: {
            slidesPerView: 2.4, // 768px以上では2枚表示
        },
    }
});


//////////////　ギフトページ

$(function(){
  $('.gift-menu__link').hover(
    function(){
      $('.gift-menu__link').not(this).addClass('is-dim');
  },
  function(){
    $('.gift-menu__link').removeClass('is-dim');
  }
);
});

